/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'Larger',
	['预设']: 'Default',
	['较小']: 'Smaller',
	['字级大小']: 'Font size',
	['页面正在加载中']: 'The page is loading…',
	['这可能需要几分钟的时间，请耐心等待']: 'This may take a few minutes. Please wait',
	['您所访问的页面不存在']: 'The page you are looking for does not exist.',
	['开始对话']: 'Start conversation',
	['充值未到帐快速通道']: 'Deposit Not Received – Fast Track',
	['人工客服']: 'Human customer service',
	['已接听']: 'Connected',
	['结束对话']: 'End conversation',
	['联络人工客服']: 'Contact Live Agent',
	['重新选择智能客服']: 'Reselect Virtual Assistant',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'Thank you for using our service. Please take the time to complete the survey. Your valuable feedback is our motivation to move forward!',
	['您觉得此次的服务品质如何？']: 'How would you rate the quality of this service?',
	['颗星']: 'stars',
	['颗星(單數)']: 'star',
	['不评分']: 'No rating',
	['点选下方即可结束对话']: 'Click below to end the conversation.',
	['请输入您的ID']: 'Please enter your ID.',
	['ID不能为空']: 'ID cannot be empty.',
	['说明文字']: 'Description',
	['送出']: 'Submit',
	['系统维护中']: 'System maintenance in progress.',
	['储存']: 'Save',
	['确认']: 'Confirm',
	['取消']: 'Cancel',
	['完成']: 'Completed',
	['协作']: 'Collaboration',
	['转接']: 'Transfer',
	['离开']: 'Leave',
	['请选择服务对象开始通话']: 'Please select the service target to start the call.',
	['请填写表单']: 'Please fill out the form',
	['本对话已经结束']: 'The conversation has ended.',
	['客服已逾 {{second}} 秒未回应']: 'Customer service has not responded for more than {{second}} seconds.',
	['历史对话']: 'Historical dialogue',
	['查无资料']: 'No information found.',
	['标签']: 'Label',
	['正在输入中...']: 'Typing in progress...',
	['于']: 'at',
	['档案容量限制']: 'File size limit',
	['不能为空']: 'Cannot be empty',
	['提交']: 'Submit',
	['满意度']: 'Satisfaction',
	['IP未知']: 'Unknown IP',
	['地区未知']: 'Unknown region',
	['使用者环境未知']: 'Unknown user environment',
	['关闭']: 'Close',
	['全萤幕截图成档案']: 'Capture full screen to a file.',
	['Mac用户']: 'Mac users',
	['Windows用户']: 'Windows users',
	['Windows键']: 'Windows key',
	['全萤幕截图至剪贴簿']: 'Capture full screen and save to clipboard.',
	['截图完成后请直接于文字输入处贴上']: 'Please paste it directly into the text input field after the screenshot is completed.',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Please use the Windows built-in screenshot tool or QQ screenshot. After capturing, paste it directly into the message box.',
	['截图']: 'Screenshot',
	['档案']: 'File',
	['下载失败']: 'Download failed.',
	['请输入分类名称']: 'Please enter the category name.',
	['新增']: 'Add',
	['更新']: 'Update',
	['请选择一个分类']: 'Please select a category.',
	['请输入标题']: 'Please enter a title.',
	['请输入内文']: 'Please enter the content.',
	['请上传图片']: 'Please upload a picture.',
	['快捷语']: 'Shortcut language',
	['图片']: 'Image',
	['管理分类']: 'Management category',
	['新增分类']: 'Add category',
	['标题/内文']: 'Title/Content',
	['分类']: 'Category',
	['编辑']: 'Editor',
	['删除']: 'Delete',
	['平台名称']: 'Platform name',
	['显示']: 'Display',
	['编辑服务平台']: 'Editing service platform',
	['若有服务中的客户，无法关闭服务平台']: 'If there are customers in service, the service platform cannot be closed.',
	['确定']: 'Confirm',
	['人员列表']: 'Personnel List',
	['服务人数']: 'Number of service personnel',
	['选择转接人员']: 'Select transfer personnel',
	['按此上传图片']: 'Upload image here.',
	['确定要取消{{displayName}}协作邀请吗？']: 'Are you sure you want to cancel the collaboration invitation for {{-displayName}} ?',
	['确定要结束{{displayName}}的协作吗？']: 'Are you sure you want to end the collaboration with {{-displayName}} ?',
	['等待协作中']: 'Waiting for collaboration',
	['协作中']: 'In collaboration',
	['负责人']: 'Person in charge',
	['已选择']: 'Selected',
	['可协作人数已满']: 'The maximum number of collaborators has been reached.',
	['选择协作人员']: 'Select collaborators',
	['提示']: 'Tip',
	['请输入讯息']: 'Please enter the message.',
	['确定已經完成？']: 'Is it confirmed that it has been completed?',
	['常用图片']: 'Commonly used images',
	['用户']: 'User',
	['个人']: 'Individual',
	['公共']: 'Public',
	['开始谈话']: 'Start the conversation.',
	['等待中']: 'Waiting',
	['客户已离开对话']: 'Customer has left the conversation.',
	['正在转接给']: 'Transferring to',
	['邀请你加入协作']: 'Invitation to join collaboration',
	['请求转接']: 'Request transfer',
	['正在服务中']: 'In service',
	['编辑平台']: 'Editing platform',
	['您的连线已中断']: 'Your connection has been interrupted.',
	['正尝试重新连线']: 'Attempting to reconnect',
	['重新登入']: 'Re-login',
	['请先登入']: 'Please log in first.',
	['帐号']: 'Account',
	['帐号不能为空']: 'Account cannot be empty.',
	['请输入帐号']: 'Please enter your account.',
	['密码']: 'Password',
	['密码不能为空']: 'Password cannot be empty.',
	['请输入密码']: 'Please enter password.',
	['登录']: 'Login',
	['客服系统客服端']: 'Customer service system client',
	['平台异动，请重新整理']: 'Platform abnormality, please refresh',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'Customer service system is undergoing maintenance and upgrade. Please contact online customer service later. Thank you.',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'Customer service system is undergoing upgrade and maintenance work. We apologize for interrupting your conversation. Please contact online customer service later.',
	['请稍后再试']: 'Please try again later.',
	['是']: 'Yes',
	['否']: 'No',
	['等于']: 'Equal to',
	['包含']: 'Include',
	['排除']: 'Exclude',
	['大于']: 'Greater than',
	['少于']: 'Less than',
	['数量区间']: 'Quantity Range',
	['客服对话数']: 'Number of customer service conversations',
	['客戶对话数']: 'Number of customer conversations',
	['即时资讯']: 'Real-time information',
	['报表分析']: 'Report analysis',
	['平均通话时间']: 'Average call duration',
	['回覆通话数']: 'Reply call count',
	['平均等待时间']: 'Average waiting time',
	['客户满意度']: 'Customer satisfaction',
	['历史对话记录']: 'Historical conversation records',
	['操作日志']: 'Operation log',
	['智能客服设定']: 'Intelligent customer service settings',
	['机器人设定']: 'Robot settings',
	['版本管理']: 'Version control',
	['档案总览']: 'File Overview',
	['设定']: 'Setting',
	['公司管理']: 'Company management',
	['维修管理']: 'Maintenance management',
	['一般设定']: 'General settings',
	['公告管理']: 'Announcement management',
	['帐号管理']: 'Account management',
	['平台管理']: 'Platform management',
	['角色管理']: 'Role management',
	['团队管理']: 'Team management',
	['标签管理']: 'Label management',
	['查询']: 'Query',
	['重置']: 'Reset',
	['今天']: 'Today',
	['昨天']: 'Yesterday',
	['过去7天']: 'Past 7 days',
	['过去10天']: 'Past 10 days',
	['过去一个月']: 'In the past month',
	['过去90天']: 'Past 90 days',
	['LOGO 预览']: 'LOGO Preview',
	['档案格式：PNG、JPG，长宽不超过']: 'File format: PNG, JPG, with a maximum width and height of',
	['档案太大或格式不支援']: 'File is too large or format is not supported.',
	['且档案大小不得大于']: 'And the file size must not exceed',
	['上传档案']: 'Upload file',
	['新增IP白名单成功']: 'Add IP whitelist successfully.',
	['删除IP白名单成功']: 'Successfully deleted IP whitelist.',
	['请输入欲查询的IP']: 'Please enter the IP you want to query.',
	['请输入IP']: 'Please enter the IP.',
	['备注']: 'Note',
	['备注不能为空']: 'The remarks cannot be empty.',
	['请输入备注']: 'Please enter a remark.',
	['新增时间']: 'Add Time',
	['操作']: 'Operation',
	['IP白名单']: 'IP whitelist',
	['新增IP']: 'Add IP',
	['新增IP白名单']: 'Add IP whitelist',
	['确定删除此IP?']: 'Are you sure you want to delete this IP?',
	['平台']: 'Platform',
	['团队']: 'Team',
	['全体']: 'All',
	['客服']: 'Customer service',
	['客服系统']: 'Customer service system',
	['个人帐号设定']: 'Personal Account Settings',
	['最少6码']: 'Minimum 6 characters',
	['最多20码']: 'Maximum 20 characters',
	['不能有空白']: 'Cannot have spaces.',
	['应至少包含1个英文和数字']: 'Should contain at least 1 English letter and number.',
	['公司名称']: 'Company Name',
	['僅能输入英文和数字']: 'Only English letters and numbers are allowed.',
	['应至少包含1个英文']: 'Should contain at least 1 English character.',
	['最少5码']: 'Minimum 5 yards',
	['IP不能为空']: 'IP cannot be empty.',
	['非IP位址']: 'Non-IP address',
	['最多500个字']: 'Maximum 500 characters',
	['启用']: 'Enabled',
	['禁用']: 'Disabled',
	['对话量']: 'Conversation volume',
	['目前客户数']: 'Current number of customers',
	['目前客服数']: 'Current number of customer service representatives',
	['接通对话量']: 'Connected conversation volume',
	['全部']: 'All',
	['最近一天']: 'Last day',
	['最近一周']: 'Last week',
	['最近一月']: 'Last month',
	['新增过滤器']: 'Add filter',
	['请输入模組名称']: 'Please enter the module name.',
	['储存过滤模組']: 'Storage filter module',
	['读取过滤模組']: 'Read filter module',
	['确定要删除模組']: 'Confirm to delete the module.',
	['分钟']: 'Minutes',
	['接通时间']: 'Connection time',
	['通话时间']: 'Call duration',
	['请选择或输入时间']: 'Please select or enter a time.',
	['等待时间']: 'Waiting time',
	['对话搜寻']: 'Dialogue search',
	['请输入对话']: 'Please enter the dialogue.',
	['客戶 ID']: 'Customer ID',
	['请输入客戶ID']: 'Please enter customer ID.',
	['对话浏览模式']: 'Conversation browsing mode',
	['筆']: 'Case',
	['客服本名']: 'Customer Service Real Name',
	['进入时间']: 'Entry time',
	['客服昵称']: 'Customer Service Nickname',
	['客服系统管理端']: 'Customer Service System Management Platform',
	['数量']: 'Quantity',
	['尚未上传档案']: 'File not uploaded yet.',
	['输入文字']: 'Text input',
	['请在此输入文字']: 'Please enter text here.',
	['添加项目']: 'Add project',
	['请选择']: 'Please select',
	['新增文字']: 'Add Text',
	['新增档案']: 'Add new file',
	['選項']: 'Options',
	['勾选标题']: 'Check the title',
	['文字內容不能为空']: 'The text content cannot be empty.',
	['添加']: 'Add',
	['上传标题']: 'Upload Title',
	['单选标题']: 'Single choice title',
	['输入框标题']: 'Input field title',
	['请输入']: 'Please enter.',
	['输入框']: 'Text box',
	['单选']: 'Single choice',
	['核取方块']: 'Checkbox',
	['请选择一个标签']: 'Please select a label.',
	['确定要删除此项目和其所有子项目？']: 'Are you sure you want to delete this project and all its sub-projects?',
	['答案']: 'Answer',
	['表单']: 'Form',
	['清除此阶层设定']: 'Remove this hierarchical setting.',
	['请输入此阶层问题']: 'Please enter this class problem.',
	['新增选项']: 'Add option',
	['新增表单']: 'Add form',
	['新增答案']: 'Add Answer',
	['新增充值表单']: 'Add Recharge Form',
	['若切换种类后, 将清除原有的和其子项目资料']: 'If you switch categories, the original and its sub-item data will be cleared.',
	['确定要清除所有资料和其子项目资料？']: 'Are you sure you want to delete all data and its subproject data?',
	['阶层']: 'Factorial',
	['开场语']: 'Opening remarks',
	['开场语不能为空']: 'The opening remarks cannot be empty.',
	['结尾感谢语']: 'Closing gratitude',
	['结尾感谢语不能为空']: 'The ending gratitude cannot be empty.',
	['发布']: 'Publish',
	['复制']: 'Copy',
	['选择目的平台']: 'Select target platform',
	['确定复制到']: 'Copy to',
	['是否要正式发布到使用环境？']: 'Do you want to formally release it to the production environment?',
	['储存版本']: 'Storage Version',
	['版本名称']: 'Version Name',
	['请输入版本名称']: 'Please enter the version name.',
	['确定是否储存此版本']: 'Confirm whether to save this version.',
	['版本储存成功']: 'Version storage successful.',
	['最多10个字']: 'Up to 10 characters',
	['公告一']: 'Announcement 1',
	['公告二']: 'Announcement 2',
	['公告三']: 'Announcement 3',
	['公告储存成功']: 'Announcement storage successful.',
	['标题']: 'Title',
	['內文']: 'Content',
	['修改登入密码']: 'Change login password',
	['修改基本资讯']: 'Edit basic information',
	['昵称']: 'Nickname',
	['昵称不能为空']: 'Nickname cannot be empty.',
	['请输入昵称']: 'Please enter a nickname.',
	['本名']: 'Name',
	['本名不能为空']: 'The name cannot be empty.',
	['请输入本名']: 'Please enter your full name.',
	['选择图像']: 'Select Image',
	['状态']: 'Status',
	['平台代码']: 'Platform code',
	['平台代码不能为空']: 'Platform code cannot be empty.',
	['使用ID模式登入']: 'Login using ID mode',
	['新增平台']: 'Add platform',
	['修改平台']: 'Edit platform',
	['确定重新产生Key/IV?']: 'Confirm to regenerate Key/IV?',
	['进入公司成功']: 'Successfully entered the company.',
	['确定禁用公司?']: 'Disable company?',
	['确定启用公司?']: 'Enable company?',
	['修改公司']: 'Change company',
	['进入公司']: 'Enter the company',
	['确定进入公司?']: 'Confirm entering the company?',
	['新增标签']: 'Add tag',
	['代号']: 'Code',
	['代号不可为空']: 'Code cannot be empty.',
	['名称']: 'Name',
	['名称不可为空']: 'Name cannot be empty.',
	['颜色']: 'Color',
	['颜色不可为空']: 'Color cannot be empty.',
	['进入标签']: 'Enter tag',
	['修改标签']: 'Edit label',
	['确定开启进入标签?']: 'Confirm to enable entering the label?',
	['确定关闭进入标签?']: 'Confirm closing the entry tag?',
	['确定删除此标签?']: 'Are you sure you want to delete this tag?',
	['标签创建成功']: 'Label created successfully.',
	['标签更新成功']: 'Label update successful.',
	['进入标签更新成功']: 'Successfully entered tag update.',
	['标签删除成功']: 'Label deleted successfully.',
	['请输入代号、名称等关键字']: 'Please enter the code, name, or other keywords.',
	['设定开场白成功']: 'Set opening remarks successfully.',
	['客戶进入开场白']: 'Customer enters the opening remarks.',
	['客戶进入开场白不可为空']: 'The customer\'s entry into the opening remarks cannot be empty.',
	['第一次通知时间']: 'First notification time',
	['第{{count}}次通知时间']: 'Notification time for the {{count}} time',
	['设置错误']: 'Setting error',
	['设定等待过长通知时间成功']: 'Successfully set the notification time for waiting too long.',
	['秒']: 'Seconds',
	['对话自动断开时间']: 'Automatic Disconnect Time for Conversation',
	['未发话时间']: 'No speaking time',
	['未发话提示文字']: 'No speech prompt text',
	['设定对话断开成功']: 'Set conversation disconnect successful.',
	['Favicon预览']: 'Favicon Preview',
	['更换 Favicon 成功']: 'Favicon replacement successful.',
	['档案格式：ICO，長寬不超過 32x32 px']: 'File format: ICO, dimensions not exceeding 32x32 px',
	['更换 LOGO 成功']: 'Logo replacement successful.',
	['智能客服']: 'Virtual Assistant',
	['设定通道成功']: 'Set channel successfully.',
	['设定提示音效成功']: 'Set sound effect successfully.',
	['单音']: 'Monotone',
	['循环音']: 'Looping sound',
	['编号']: 'Number',
	['资料类型']: 'Data type',
	['资料类型不可为空']: 'Data type cannot be empty.',
	['数字']: 'Number',
	['字串']: 'String',
	['布林']: 'Boolean',
	['建立标签成功']: 'Successfully created a label.',
	['修改标签成功']: 'Successfully modified the label.',
	['删除标签成功']: 'Successfully deleted the tag.',
	['更换 LOGO']: 'Change LOGO',
	['更换 Favicon']: 'Change Favicon',
	['对话断开']: 'Disconnected conversation',
	['等待过长通知时间']: 'Excessive waiting notification time',
	['开场白']: 'Opening remarks',
	['提示音效设定']: 'Prompt sound effect settings',
	['通道设定']: 'Channel setting',
	['自定义标签']: 'Custom label',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'Enabling maintenance mode will stop the operation of the customer service system. Are you sure you want to enable it?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'Turn off maintenance mode, the customer service system will continue to operate. Are you sure you want to turn it off?',
	['状态更新成功']: 'Status update successful.',
	['通知讯息更新成功']: 'Notification message update successful.',
	['维修模式']: 'Maintenance mode',
	['通知讯息设定']: 'Notification message settings',
	['尚未连线状态']: 'Not yet connected status',
	['尚未连线状态描述']: 'Description of not yet connected status',
	['已连线状态']: 'Connected status',
	['已连线状态描述']: 'Connected status description',
	['开启成功']: 'Successful activation',
	['关闭成功']: 'Successful shutdown',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'Turning off login management mode will restrict customers from entering customer service by entering their ID. Are you sure you want to turn it off? (If customer profile information is not provided, an error page will be displayed.)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'Enabling login management mode will allow customers to enter customer service by entering their ID. Are you sure you want to enable it?',
	['请输入帐号、昵称、角色等关键字']: 'Please enter keywords such as account, nickname, role, etc.',
	['新增角色']: 'Add new role',
	['修改角色']: 'Edit role',
	['角色创建成功']: 'Role creation successful.',
	['角色更新成功']: 'Role update successful.',
	['角色删除成功']: 'Role deletion successful.',
	['请输入角色名称，平台，权限等关键字']: 'Please enter the role name, platform, and keywords for permissions.',
	['关键字']: 'Keyword',
	['角色名称']: 'Role Name',
	['角色名称不可为空']: 'Role name cannot be empty.',
	['请输入角色名称']: 'Please enter the role name.',
	['上级角色']: 'Superior role',
	['上级角色不可为空']: 'The superior role cannot be empty.',
	['权限']: 'Permission',
	['确定删除此角色?']: 'Are you sure you want to delete this role?',
	['图像不能为空']: 'Image cannot be empty.',
	['新增团队']: 'Add Team',
	['修改团队']: 'Edit team',
	['团队创建成功']: 'Team created successfully.',
	['团队修改成功']: 'Team modification successful.',
	['团队删除成功']: 'Team deletion successful',
	['人数']: 'Number of people',
	['新登入密码']: 'New login password',
	['新密码不能设定與舊密码相同']: 'The new password cannot be set the same as the old password.',
	['新密码與確認密码不相同']: 'The new password and the confirmed password do not match.',
	['确定修改登入密码?']: 'Confirm to modify login password?',
	['登入密码修改成功，请重新登入']: 'Password modification successful, please log in again.',
	['个人资讯']: 'Personal information',
	['搜寻快捷语']: 'Search shortcuts',
	['登出']: 'Logout',
	['帐密错误']: 'Incorrect username or password',
	['一']: 'One',
	['二']: 'Two',
	['三']: 'Three',
	['四']: 'Four',
	['五']: 'Five',
	['六']: 'Six',
	['七']: 'Seven',
	['请输入客服本名、客服昵称等关键字']: 'Please enter keywords such as customer service\'s real name, customer service\'s nickname, etc.',
	['共 {{count}} 筆资料']: 'Total {{count}} data entries.',
	['平台语言不能为空']: 'The language of platform  cannot be empty',
	['开启']: 'Open',
	['语言']: 'Language',
	['切换语言']: 'Switch language',
	['语言名称']: 'Language Name',
	['系统设定']: 'System settings',
	['储存成功']: 'Stored successfully.',
	['发布成功']: 'Published successfully.',
	['复制成功']: 'Copy successful',
	['项目选取']: 'Project selection',
	['图像']: 'Image',
	['角色']: 'Role',
	['新增帐号']: 'Add account',
	['角色不能为空']: 'The role cannot be empty.',
	['登入密码']: 'Login password',
	['请输入代号、名称、备注等关键字']: 'Please enter the code, name, remarks, and other keywords.',
	['确定删除此团队?']: 'Are you sure you want to delete this team?',
	['切换语言成功']: 'Language switched successfully.',
	['确定要切换语言?']: 'Are you sure you want to switch languages?',
	['选项']: 'Options',
	['选择语言']: 'Select Language',
	['修改成功']: 'Modification successful.',
	['舊登入密码']: 'Old password',
	['確認新登入密码']: 'Confirm new login password',
	['语言切换成功，將重整页面以套用更新']: 'Language switch successful, refreshing the page to apply updates.',
	['笔 / 页']: 'Record / Page',
	['时段搜寻']: 'Time period search',
	['请选择时段']: 'Please select a time period.',
	['更换背景色']: 'Change background color',
	['设定背景颜色成功']: 'Set background color successfully.',
	['请重新登入']: 'Please log in again.',
	['绑定谷歌验证']: 'Enable Google Authenticator',
	['解除绑定']: 'Unbind',
	['谷歌验证状态']: 'Google verification status',
	['已绑定']: 'Bound',
	['未绑定']: 'Not bound',
	['解绑谷歌验证失败']: 'Failed to solve Google verification',
	['二维码方式添加']: 'QR code method for adding',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'Please add by scanning the barcode in Google Authenticator.',
	['密钥方式添加']: 'Key mode added',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'Please add the provided key by selecting the input method in Google Authenticator.',
	['密钥如下所示']: 'The key is as follows.',
	['请再次输入登入密码']: 'Please enter the login password again.',
	['谷歌6位动态密码']: 'Google 6-digit dynamic password',
	['请绑定谷歌验证']: 'Please bind Google Authenticator.',
	['谷歌验证绑定成功']: 'Google verification binding successful',
	['解绑谷歌验证成功']: 'Unbind Google verification successful.',
	['确定解绑谷歌验证？']: 'Confirm unbinding Google verification?',
	['请输入谷歌动态码']: 'Please enter Google verification code.',
	['谷歌动态码']: 'Google Authenticator',
	['谷歌动态码不能为空']: 'Google dynamic code cannot be empty.',
	['谷歌动态码长度6码']: 'Google dynamic code length is 6 digits.',
	['谷歌动态码错误']: 'Google dynamic code error',
	['內容']: 'Content',
	['搜寻']: 'Search',
	['连线中断，点击“确定”即重新连线客服。']: 'Connection interrupted, click "OK" to reconnect with customer service.',
	['充值表单']: 'Recharge Form',
	['网银充值']: 'Online Banking Deposit',
	['扫码充值']: 'Scan to Deposit',
	['带入目前帐号']: 'Enter current account',
	['自行输入平台帐号']: 'Enter platform account manually.',
	['充值方式']: 'Deposit method',
	['平台帐号']: 'Platform account',
	['充值金额']: 'Recharge amount',
	['付款人姓名']: 'Payer\'s Name',
	['确认语']: 'Confirmation phrase',
	['操作时间']: 'Operation time',
	['操作者']: 'Operator',
	['请输入备注等关键字']: 'Please enter remarks or keywords.',
	['操作类型']: 'Operation type',
	['修改平台昵称']: 'Change platform nickname',
	['修改平台昵称成功']: 'Successfully modified platform nickname.',
	['输入格式错误']: 'Incorrect input format',
	['套用']: 'Apply',
	['确定套用到']: 'Apply to',
	['套用成功']: 'Applied successfully.',
	['储存方式']: 'Storage method',
	['储存時間']: 'Storage time',
	['系统发布']: 'System release',
	['手动储存']: 'Manual storage',
	['自动储存']: 'Automatic storage',
	['预览']: 'Preview',
	['最多350个字']: 'Maximum 350 characters',
	['修改']: 'Edit',
	['共同资讯管理']: 'Shared Information Management',
	['共同资讯创建成功']: 'Information creation successful',
	['共同资讯修改成功']: 'Information modification successful',
	['新增共同资讯']: 'Add shared information',
	['修改共同资讯']: 'Edit shared information',
	['删除成功']: 'Deletion successful.',
	['已设置于其他答案，无法删除']: 'Already set in another answer, cannot be deleted.',
	['请输入名称、内容等关键字']: 'Please enter the name, content, and other keywords.',
	['确定删除此共同资讯？']: 'Are you sure you want to delete this shared information?',
	['共同资讯']: 'Common Information',
	['尚未选择共同资讯']: 'No common information selected yet.',
	['选择共同资讯']: 'Selected Common Information',
	['选择']: 'Selection',
	['点击「确定」后，即覆盖该平台的快捷语设定']: 'After clicking "OK", the shortcut settings of the platform will be overwritten.',
	['已复制：目的平台']: 'Copied: Destination platform',
	['是否离开客服系统？']: 'Are you leaving the customer service system?',
	['感谢您的作答，此次评分为：{{score}}分']: 'Thank you for your response. Your rating for this session is {{score}}',
	['共 {{count}} 筆']: 'Total: {{count}} records',
	['分']: 'Minute',
	['新增公司']: 'Add Company',
	['翻译']: 'Translate',
	['显示原文']: 'Display original text',
	['解绑谷歌验证']: 'Unbind Google Authentication',
	['请输入名称 内容等关键字']: 'Please enter the name, content, and other keywords.',
	['表单选项']: 'Form options',
	['年']: 'Year',
	['等待时间颜色设定']: 'Waiting time color setting',
	['显示颜色']: 'Display color',
	['确认删除此规则?']: 'Confirm deleting this rule?',
	['页签']: 'Tab',
	['超过 {{time}} 分钟']: 'More than {{-time}} minutes.',
	['新增成功']: 'Addition successful',
	['删除完成']: 'Deletion completed.',
	['等待时间(分钟)']: 'Waiting time (minutes)',
	['时间']: 'Time',
	['不可为空']: 'Cannot be empty',
	['需为正整数']: 'Must be a positive integer.',
	['按平台名称排列(A-Z)']: 'Sorted by platform name (A-Z)',
	['按平台名称排列(Z-A)']: 'Sort by platform name (Z-A)',
	['旧版面模式']: 'Old interface mode',
	['自动翻译']: 'Automatic translation',
	['功能設定']: 'Settings',
	['确认切换版面？']: 'Confirm switch layout?',
	['确认开启自动翻译？']: 'Confirm to enable automatic translation?',
	['确认关闭自动翻译？']: 'Confirm to close automatic translation?',
	['原文']: 'Original text',
	['泰语']: 'Thai',
	['追踪']: 'Tracking',
	['取消追踪']: 'Cancel tracking',
	['预览影片']: 'Preview video',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'Only MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, and HEIF files are allowed to be uploaded.',
	['请勿输入语法相关字串']: 'Please do not enter syntax-related strings.',
	['输入名称']: 'Input name',
	['设为预设版本']: 'Set as default version',
	['另存为新版本']: 'Save as new version',
	['请选择版本']: 'Please select a version.',
	['一键开关']: 'One-click switch',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'If there are customers in service, the service platform cannot be closed and the version cannot be switched.',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'Are you sure you want to overwrite the existing settings and save the new settings?',
	['已储存超过五个版本']: 'Saved more than five versions',
	['版本已变动，是否需要储存？']: 'The version has changed, do you want to save?',
	['确定删除此版本？']: 'Are you sure you want to delete this version?',
	['编辑版本']: 'Edited version',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'Duplicate customer service contact detected. If this was not initiated by you, please notify support.',
	['删除此版本']: 'Delete this version',
	['刪除成功']: 'Delete successful.',
	['刪除失敗']: 'Deletion failed.',
	['儲存成功']: 'Saved successfully.',
	['儲存失敗']: 'Storage failed',
	['您好，请问要选择哪个问题？']: 'Hello, which issue would you like to select?',
	['等待服务区']: 'Waiting service area',
	['按时间排列(長到短)']: 'Sorted by time (long to short)',
	['按时间排列(短到長)']: 'Sorted by time (short to long)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'Welcome! We\'re happy to assist you. Please hold on while we prepare your service.',
	['编辑标签']: 'Edit tags',
	['于 {{time}} 侦测到会员【稍早已离线】']: 'Detected member 【already offline】 at {{-time}}.',
	['{{score}}分']: '{{score}} points',
	['未评分']: 'Not rated',
	['客服完成']: 'Customer service completed.',
	['会员离线']: 'Member offline',
	['超时自动断线']: 'Timeout automatic disconnection',
	['{{text}}不可重复']: '{{-text}} cannot be repeated.',
	['{{text}}不能为空']: '{{-text}} cannot be empty.',
	['{{text}}设置错误']: '{{-text}} setting error.',
	['平均通话时长']: 'Average call duration',
	['平均通话数']: 'Average number of calls',
	['请选择角色名称']: 'Please select a role name.',
	['请选择客服']: 'Please select customer service.',
	['请选择团队']: 'Please select a team.',
	['播放']: 'Play',
	['统计时间']: 'Statistical time',
	['统计时间不可为空']: 'The statistical time cannot be empty.',
	['请输入时间']: 'Please enter the time.',
	['时间筛选']: 'Time filter',
	['汇出']: 'Remittance',
	['未出勤']: 'Absent',
	['客服平均通话时长']: 'Average customer service call duration',
	['数量筛选']: 'Quantity Filter',
	['客服平均等待时间']: 'Average waiting time for customer service',
	['上一个月']: 'Last month',
	['导出Excel成功']: 'Export Excel successfully.',
	['对话结束']: 'Conversation ended.',
	['满意度/客服']: 'Satisfaction/Customer Service',
	['日期/客服']: 'Date/Customer Service',
	['总数']: 'Total',
	['日平均']: 'Daily average',
	['客服日均量']: 'Average daily volume of customer service',
	['客服通话总量']: 'Total number of customer service calls',
	['日总量']: 'Daily total',
	['请输入数量']: 'Please enter the quantity.',
	['满意度预设分数']: 'Satisfaction preset score',
	['当会员未评分，会自动给予此预设分数。']: 'When the member has not rated, a default score will be automatically given.',
	['设定满意度预设分数成功']: 'Set satisfaction preset score successfully',
	['客户满意度管理']: 'Customer satisfaction management',
	['对话结束方式']: 'Conversation ending method',
	['对话满意度']: 'Dialogue satisfaction',
	['时段']: 'Time period',
	['客服平均满意度']: 'Average customer satisfaction',
	['公用设定']: 'Public settings',
	['通话时长']: 'Call duration',
	['服务时段']: 'Service hours',
	['储存时间']: 'Storage time',
	['客服不可为空']: 'The customer service field cannot be empty.',
	['团队不可为空']: 'The team field cannot be empty.',
	['请输入对话内容关键字']: 'Please enter the keyword for the conversation content.',
	['请输入客服本名、昵称或帐号']: 'Please enter keywords such as customer service\'s real name, customer service\'s nickname, etc.',
	['平台不可为空']: 'The platform field cannot be empty.',
	['线上']: 'Online',
	['离线']: 'Offline',
	['日期不可为空']: 'Date cannot be empty.',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'Dear, just to confirm with you again, the account for applying and making this deposit of  {{chargeNumber}}  dollars is  {{chargeAccount}}, right?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'Your current queue position is: {{pendingOrder}}',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: 'Refused to transfer from {{-inviter}} to {{-invitee}}.',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{-name}} has closed the window at {{-time}}.',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{-name}} has completed the case selected at {{-time}}.',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{-name}} has successfully joined the collaboration at {{-time}}.',
	['{{name}} 已于 {{time}} 离开协作']: '{{-name}} has left the collaboration at {{-time}}.',
	['{{name}} 已于 {{time}} 中断连线']: '{{-name}} has been disconnected at {{-time}}.',
	['英文']: 'English',
	['验证码设定']: 'Verification code setting',
	['启用验证码']: 'Enable CAPTCHA',
	['设定验证码成功']: 'Set verification code successfully.',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'After enabling the captcha function, customers need to complete the verification before entering the waiting area of the customer service system.',
	['禁止连续发话']: 'Continuous messaging is not allowed.',
	['启用禁止连续发话']: 'Enable "No Continuous Speaking" function.',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'When a member exceeds the set number of times of speaking within the "time limit", the system will automatically display a warning.',
	['客户端限制于']: 'Client limited to',
	['发话次数达到']: 'Number of times spoken reached',
	['次']: 'Times',
	['暂时无法发话']: 'Unable to speak temporarily',
	['储存完成']: 'Storage completed',
	['发送消息过于频繁 可稍后再试']: 'Sending messages too frequently. Please try again later.',
	['IP黑名单管理']: 'IP blacklist management',
	['共 {{total}} 笔']: 'Total: {{total}} record',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '{{min}} - {{max}} out of {{total}} record',
	['顯示']: 'Display',
	['查询IP黑名单']: 'Query IP blacklist',
	['设定自动添加黑名单']: 'Set automatic blacklist addition',
	['白名單管理']: 'Whitelist management',
	['解除时间']: 'Release time',
	['永久封锁']: 'Permanent ban',
	['新增IP黑名单']: 'Add IP blacklist',
	['加入黑名单后，该IP将无法进入客服前台。']: 'After being added to the blacklist, this IP will not be able to access the customer service front-end.',
	['请完成安全验证']: 'Please complete the security verification.',
	['向右滑动填充拼图']: 'Slide to the right to fill the puzzle.',
	['启用功能']: 'Enable function',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'If the IP exceeds the set "login times" within the "restricted time", the system will automatically add it to the blacklist.',
	['限制时间']: 'Time limit',
	['时间单位不可为空']: 'The time unit cannot be empty.',
	['时间单位']: 'Time unit',
	['登入次数']: 'Login count',
	['封锁时间']: 'Block time',
	['锁的持续时间，时间到了会自动解除']: 'Duration of the lock, it will be automatically released when the time is up.',
	['查询IP白名单']: 'Query IP whitelist',
	['删除失败']: 'Deletion failed.',
	['修改失败']: 'Modification failed.',
	['拼图验证失败次数过多']: 'Too many failed puzzle verifications.',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{-name}} has declined to join the collaboration at {{-time}}.',
	['储存过滤模組成功']: 'Storage filter module successfully stored.',
	['删除过滤模組成功']: 'Successfully deleted the filtering module.',
	['解除谷歌验证成功']: 'Successfully removed Google verification.',
	['确定禁用平台?']: 'Are you sure you want to disable the platform?',
	['确定启用平台?']: 'Are you sure you want to enable the platform?',
	['IP管理(客户端)']: 'IP Management (Client)',
	['上传']: 'Upload',
	['此栏位的时间会使用于报表的团队筛选']: 'This field\'s time will be used for team filtering in the report.',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'Selected team: Filter out the data of all customer service personnel in the team during the team\'s statistical period.',
	['备注最多{{inputLimit}}个字']: 'Note can have up to {{inputLimit}} characters.',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{-inviter}} has transferred the conversation from {{-from}} to  {{-invitee}} at {{-time}}.',
	['小时']: 'Hour',
	['日']: 'Day',
	['会员IP：{{ip}} 已加入前台黑名单']: 'Member IP: {{ip}} has been added to the front-end blacklist.',
	['新增失败']: 'Addition failed',
	['会员IP被加入黑名单']: 'Member IP has been added to the blacklist.',
	['登入/接待时间']: 'Login/Reception Time',
	['timePeriodTooltipMessage']: 'The filter period can only filter time and not date. If the team\'s statistical time is set to span across days, the date will not change accordingly. \nFor example:\nTeam\'s statistical time is set to 23:00-07:30 \nQuery is for 9/1 00:00-23:59 \nFilter time is 02:00-03:00 \nAfter filtering, the data for 9/1 will be 9/1 02:00-03:00 \nThis data result does not intersect with the team\'s statistical time for 9/1 (9/1 23:00-9/2 07:30), so the data will be 0.',
	['平均接待时间']: 'Average reception time',
	['平均登入时间']: 'Average login time',
	['接待时间报表']: 'Reception Time Report',
	['登入时间报表']: 'Login Time Report',
	['未登入']: 'Not logged in',
	['设定报表']: 'Set up report',
	['设定对话是否记入报表中']: 'Set whether the conversation is recorded in the report.',
	['平均通话时长报表']: 'Average Call Duration Report',
	['平均通话数报表']: 'Average Call Volume Report',
	['平均等待时间报表']: 'Average Waiting Time Report',
	['客户满意度报表']: 'Customer Satisfaction Report',
	['平均回覆时间报表']: 'Average response time report',
	['调整原因']: 'Reason for adjustment',
	['请输入调整原因']: 'Please enter the reason for adjustment.',
	['调整原因不可为空']: 'The reason for adjustment cannot be empty.',
	['日期时间']: 'Date and time',
	['操作人']: 'Operator',
	['原因']: 'Reason',
	['更多']: 'More',
	['收回']: 'Withdraw',
	['设定报表成功']: 'Set report successfully.',
	['平均回覆时间']: 'Average response time',
	['客服平均回覆时间']: 'Average customer service response time',
	['客户回头率']: 'Customer retention rate',
	['客户ID']: 'Customer ID',
	['客服帐号']: 'Customer service account',
	['小时回头率']: 'Hourly re-entry consultation rate',
	['日回头率']: 'Daily re-entry consultation rate',
	['遗漏时间']: 'Waiting time before departure',
	['请选择遗漏时间']: 'Please select the range of waiting time before departure.',
	['平均遗漏时间']: 'Average waiting time before departure',
	['1分钟']: '1 minute',
	['2分钟']: '2 minutes',
	['3分钟']: '3 minutes',
	['4分钟']: '4 minutes',
	['5分钟']: '5 minutes',
	['离开时间']: 'Departure time',
	['客户回头率报表']: 'Customer Re-engagement Rate Report',
	['平台报表']: 'Platform report',
	['对话总量']: 'Total number of dialogues',
	['接待总量']: 'Total number of receptions',
	['遗漏总量']: 'Total number of missing cases',
	['智能客服总量']: 'Total number of intelligent customer service',
	['智能转客服总量']: 'Total number of intelligent transfer customer service',
	['最后更新时间']: 'Last updated time',
	['客服人数']: 'Customer service staff number',
	['在线客服总数']: 'Total number of online customer service representatives',
	['等待服务']: 'Waiting for service',
	['正在服务']: 'Serving',
	['智能未转客服总量']: 'Total number of intelligent unconverted customer service',
	['使用平台']: 'Platform used',
	['泰文名称']: 'Thai name',
	['请输入泰文名称']: 'Please enter the Thai name.',
	['英文名称']: 'English name',
	['请输入英文名称']: 'Please enter the English name.',
	['中文名称']: 'Chinese name',
	['请输入中文名称']: 'Please enter the Chinese name.',
	['若无需翻译请填写中文']: 'If no translation is needed, please write in Chinese.',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'All report data associated with the account will be deleted along with the account. Are you sure you want to proceed with the deletion?',
	['停用']: 'Disabled',
	['停用帐号']: 'Disabled account',
	['通话总数']: 'Total number of calls',
	['等待中人数：{{pendingConversationCount}} 人']: 'The number of people waiting is {{pendingConversationCount}}',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'The report is being exported. Please go to the "Report Download" page to check the progress and proceed with the download.',
	['汇出Load Data']: 'Export Load Data',
	['报表下载']: 'Report download',
	['全平台']: 'Cross-platform',
	['报表类型']: 'Report type',
	['数据范围']: 'Data Range',
	['汇出时间']: 'Remittance time',
	['完成时间']: 'Completion time',
	['申请者']: 'Applicant',
	['下载']: 'Download',
	['重新汇出']: 'Reissue',
	['处理中']: 'Processing',
	['已完成']: 'Completed',
	['失败']: 'Failure',
	['下载成功']: 'Download successful.',
	['历史对话纪录']: 'Historical conversation records',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'Connection lost. Click "Confirm" to reconnect. If it fails, the chat will end.',
	['引用功能管理']: 'Quotation Function Management',
	['引用对话']: 'Quoted dialogue',
	['设定引用对话成功']: 'Set reference dialogue successfully.',
	['客户管理']: 'Customer management',
	['重要客户帐号']: 'Important customer account',
	['请输入重要客户帐号、备注等关键字']: 'Please enter important customer account numbers, notes, and other keywords.',
	['新增重要客户']: 'Add important customers',
	['重要客户帐号不能为空']: 'Important customer account cannot be empty.',
	['输入多个帐号请用, 区隔']: 'Please separate multiple accounts with commas.',
	['修改重要客户']: 'Update important customers',
	['重要帐号']: 'Important account',
	['会员类型']: 'Membership type',
	['引用']: 'Quotation',
	['收回(訊息)']: 'Withdraw',
	['收回功能管理']: 'Withdrawal function management',
	['收回提示文字不能为空']: 'The prompt text cannot be empty.',
	['收回对话']: 'Withdraw conversation',
	['收回提示文字（中文）']: 'Withdrawal prompt text (Chinese)',
	['收回提示文字（英文）']: 'Withdrawal prompt text (English)',
	['收回提示文字（泰文）']: 'Withdrawal prompt text (Thai)',
	['视频']: 'Video',
	['确定要收回讯息吗？']: 'Are you sure you want to recall the message?',
	['设定收回功能成功']: 'Set withdrawal function successfully.',
	['遗漏数据']: 'Missing case data',
	['全选']: 'Select all',
	['请选择使用平台']: 'Please select the platform to use.',
	['日期计算方式']: 'Date calculation method',
	['以会员进入正在服务区的时间计算']: 'Calculate based on the time when the member enters the service area.',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'Calculate based on the time when the member enters the waiting service area, if the member does not enter the waiting service area after clicking on the smart customer service, calculate based on the time of clicking on the smart customer service.',
	['以会员进入等待服务区的时间计算']: 'Calculate the time for members to enter the waiting service area.',
	['以客服接通对话的时间进行计算']: 'Calculate the time it takes for customer service to connect the conversation.',
	['以会员进入等待服务区的时间进行计算']: 'Calculate based on the time when the member enters the waiting service area.',
	['以会员点击智能客服的时间计算']: 'Calculated based on the time when members click on the smart customer service.',
	['相同类型才会计算回头']: 'Only the same type will be calculated for the return.',
	['登入联系离开后再次登入联系']: 'Login, contact, leave, and then login again and contact again.',
	['一通对话只会触发一次回头次数']: 'The conversation will only trigger one time of looking back.',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'Contacting 3 times within the same member\'s session, calculate 1 return visit for each of the first two conversations with customer service.',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'The ratio of effective conversations where the same member contacts again within {{-hour}} hours after the conversation ends.',
	['未登入联系离开后再次未登入联系']: 'Not logged in, left and then not logged in again and contacted',
	['请输入重要客户帐号']: 'Please enter important customer account numbers',
	['开始日期']: 'Start date',
	['结束日期']: 'End date',
	['标签名称/数量']: 'Label Name/Quantity',
	['暂无数据']: 'No data available',
	['AI客服设定']: 'AI customer service settings',
	['AI共同设定']: 'AI common setting',
	['平台AI设定']: 'Platform AI settings',
	['平台 AI SKILL 设定']: 'Platform AI SKILL settings',
	['指令输入说明']: 'Command input instructions',
	['输入文字档']: 'Text document input',
	['不需要区分功能']: 'No need to differentiate functions.',
	['套用平台']: 'Applied platform',
	['请输入指令']: 'Please enter a command.',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'After more than <<inputNumber>> rounds of AI-member conversation, it is necessary to notify customer service personnel.',
	['指令']: 'Command',
	['AI开关']: 'AI switch',
	['AI客服名称']: 'AI Customer Service Name',
	['AI客服名称不能为空']: 'AI customer service name cannot be empty.',
	['请输入AI客服名称']: 'Please enter the name of the AI customer service.',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'Do you want to disable AI customer service? Once disabled, AI customer service cannot be re-enabled.',
	['侦测到对话有异常状态，请尽快处理']: 'An abnormal conversation state was detected. Please address it as soon as possible.',
	['需要转接人工客服，请尽快处理']: 'Need to transfer to a live agent. Please handle as soon as possible.',
	['总平均通话时长']: 'Average total call duration',
	['AI平均通话时长']: 'Average call duration of AI',
	['人工平均通话时长']: 'Average call duration for manual tasks',
	['每日总平均']: 'Daily average total',
	['AI日平均']: 'Average AI per day',
	['人工日平均']: 'Average daily manual work',
	['通话总量']: 'Total number of calls',
	['AI通话总量']: 'Total number of AI calls',
	['共同']: 'Common',
	['总计']: 'Total',
	['总计请勿超过{{limit}}字']: 'The total length should not exceed {{-limit}} words',
	['总平均回覆时间']: 'Average overall response time',
	['AI平均回覆时间']: 'Average AI response time',
	['人工平均回覆时间']: 'Average response time by humans',
	['AI日总量']: 'AI daily total',
	['人工日总量']: 'Total number of manual workdays',
	['指令不能为空']: 'The command cannot be empty.',
	['{{name}} 已于 {{time}} 开启AI']: '{{-name}} has started AI at {{-time}}.',
	['{{name}} 已于 {{time}} 关闭AI']: '{{-name}} has closed AI at {{-time}}.',
	['人机合作日总量']: 'Total number of human-computer collaboration days',
	['人工通话总量']: 'Total number of manual calls',
	['人机合作通话总量']: 'Total number of human-computer collaborative calls',
	['以对话建立时间计算']: 'Calculate time based on dialogue',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'An abnormal conversation state was detected — conversation limit exceeded.',
	['侦测到对话有异常状态 - 系统发生错误']: 'An abnormal conversation state was detected — a system error occurred.',
	['人机合作-人工日平均']: 'Human-Computer Collaboration - Average Artificial',
	['人机合作-AI日平均']: 'Human-Computer Collaboration - AI Daily Average',
	['人机合作-人工平均通话时长']: 'Human-Computer Cooperation - Average Artificial Call Duration',
	['人机合作-AI平均通话时长']: 'Human-Computer Collaboration - Average AI Call Duration',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'An abnormal conversation state was detected — AI API response time exceeded two minutes.',
	['侦测到对话有异常状态 - AI 发生错误']: 'An abnormal conversation state was detected — AI encountered an error.',
	['侦测到对话有异常状态 - AI 没有回复']: 'An abnormal conversation state was detected — AI did not respond.',
	['数据']: 'Data',
	['指令不能超过{{limit}}字']: 'Commands cannot exceed {{-limit}} words',
	['数据不能为空']: 'Data cannot be empty.',
	['数据不能超过100万字']: 'Data must not exceed 1 million characters.',
	['需{{limit}}字以内']: 'Required within {{-limit}} words',
	['数据输入说明']: 'Data input instructions',
	['需100万字以内']: 'Requires fewer than 1 million characters.',
	['至少要有一组 ~~~~~ 与 =====']: 'Must contain at least one pair of ~~~~~ and =====',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'The delimiters ~~~~~ and ===== must appear in pairs',
	['需以 ===== 结尾']: 'Must end with =====',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'Put 5 tildes on the line below the title with no other text or spaces before or after them',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'Put 5 equal signs on the line below the content with no other text or spaces before or after them',
	['范例']: 'Example',
	['标题A（可多行）']: 'Title A (multiple lines allowed)',
	['内容A（可多行，可含任何文字）']: 'Content A (multiple lines, any text allowed)',
	['标题B（可多行）']: 'Title B (multiple lines allowed)',
	['内容B（可多行，可含任何文字）']: 'Content B (multiple lines, any text allowed)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'Model order (the top model is used first; on failure it automatically switches to the next one)',
	['主要']: 'Primary',
	['备援{{index}}']: 'Fallback {{index}}',
	['新增备援模型']: 'Add fallback model',
	['请输入数据']: 'Please enter data.',
	['正在转接中...']: 'Transferring...',
	['（中文）']: '(Chinese)',
	['（英文）']: '(English)',
	['（泰文）']: '(Thai)',
	['（越南文）']: '(Vietnamese)',
	['越南文名称']: 'Vietnamese name',
	['请输入越南文名称']: 'Please enter the Vietnamese name.',
	['模式']: 'Mode',
	['越南语']: 'Vietnamese',
	['IP白名单设定']: 'IP whitelist settings',
	['建立时间']: 'Creation time',
	['批次删除']: 'Batch delete',
	['请确认是否删除 IP 白名单？']: 'Please confirm whether to delete the IP whitelist?',
	['开启快捷选单']: 'Open quick menu',
	['收合快捷选单']: 'Collapse quick menu',
	['是否有收回人员讯息']: 'Is there a message withdrawal by personnel?',
	['是否有收回AI讯息']: 'Is there a message withdrawal by AI?',
	['消息已被客服撤回']: 'The message has been withdrawn by customer service.',
	['用户快捷选单管理']: 'User quick menu management',
	['电脑预览']: 'Desktop preview',
	['手机预览']: 'Mobile preview',
	['档案格式：PNG、JPG、JPEG']: 'File format: PNG, JPG, JPEG',
	['请选择上传档案']: 'Please select a file to upload.',
	['新增快捷成功']: 'Quick addition successful',
	['修改快捷成功']: 'Quick edit successful',
	['设定快捷选单成功']: 'Quick menu settings successful',
	['删除快捷成功']: 'Quick delete successful',
	['确定删除此快捷？']: 'Are you sure you want to delete this shortcut?',
	['新增内容']: 'Add Content',
	['选项內容']: 'Option content',
	['{{itemLabel}}內容不能为空']: '{{-itemLabel}} content cannot be empty',
	['请输入{{itemLabel}}标题']: 'Please enter {{-itemLabel}} title',
	['请输入{{itemLabel}}选项']: 'Please enter {{-itemLabel}} option',
	['{{text}}不可为空']: '{{-text}} cannot be empty',
	['显示更多']: 'more',
	['公告标签']: 'Notice Label',
	['请选择公告标签']: 'Please select a notice label',
	['{{text}}标题']: '{{-text}}Title',
	['{{text}}內文']: '{{-text}}Content',
	['{{text}}最多{{inputLimit}}个字']: '{{-text}}Up to {{inputLimit}} characters',
	['公告内文档案大小总计不得大于10MB']: 'The total file size of the notice content must not exceed 10MB',
	['用户尚未离开，确认要完成对话？']: 'User has not left yet. Confirm to complete the conversation?',
	['{{name}} 已于 {{time}} 离开对话']: '{{-name}} has left the conversation on {{-time}}.',
	['客服人员']: 'Customer Service',
	['*新增多个IP请使用逗号「 , 」隔开']: '*To add multiple IPs, please use commas (,) to separate them.',
	['是否新增IP白名单？']: 'Do you want to add IP whitelist?',
	['IP已存在']: 'IP already exists.',
	['监控区管理']: 'Monitoring Area Management',
	['监控区开关']: 'Monitoring Area Switch',
	['设定监控区开关成功']: 'Monitoring Area Switch set successfully.',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'After enabling this feature, a [Monitoring Area] tab will be added to the waiting service area, displaying conversations intercepted by AI across the platform along with the 5 longest unread conversations. Click to quickly jump to the corresponding conversation.',
	['{{name}} 新增了标签 {{tag}}']: '{{-name}} added label {{-tag}}',
	['{{name}} 移除了标签 {{tag}}']: '{{-name}} removed label {{-tag}}',
	['状态切换为暂离']: 'Switch status to Away',
	['状态切换为工作中']: 'Switch status to Working',
	['监控区']: 'Monitoring Area',
	['自动接线管理']: 'Automatic connection management',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'When the number of conversations across all platforms reaches the limit, the system will no longer automatically route conversations to the waiting area, but agents can manually connect without limits.',
	['自动接线数量上限']: 'Automatic connection limit',
	['设定自动接线成功']: 'Automatic connection setup successful',
	['{{name}} 进线']: '{{-name}} connected',
	['工作/暂离时间']: 'Working/Away time',
	['工作时长报表']: 'Working time report',
	['暂离时长报表']: 'Away time report',
	['平均工作时长']: 'Average working duration',
	['平均暂离时长']: 'Average away duration',
	['关键字提醒']: 'Keyword reminder',
	['客户发话']: 'Customer message',
	['AI发话']: 'AI message',
	['发话来源']: 'Message source',
	['请输入发话来源、关键字']: 'Please enter the message source and keywords',
	['新增关键字']: 'Add keyword',
	['修改关键字']: 'Edit keyword',
	['新增关键字成功']: 'Keyword added successfully',
	['修改关键字成功']: 'Keyword edited successfully',
	['删除关键字成功']: 'Keyword deleted successfully',
	['是否删除此关键字？']: 'Do you want to delete this keyword?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'Please use "；" to separate different keywords, with a maximum of 100 keywords',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'Customer triggered the keyword [{{-word}}], please take note',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI triggered the keyword [{{-word}}], please take note',
	['请输入通知时间']: 'Please enter the notification time',
	['自动接线开关']: 'Automatic connection switch',
	['自动接线数量上限不可为空']: 'The maximum limit for automatic connections cannot be empty',
	['请输入数量上限']: 'Please enter the maximum limit',
	['离开状态侦测开关']: 'Away status detection switch',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'Once enabled, customer service personnel cannot switch to away status if they are the last active staff on the platform, or if they have ongoing conversations not yet handed off to others',
	['离开时间通知开关']: 'Away time notification switch',
	['通知时间不可重复']: 'Notification times cannot be duplicated',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'Detect permissions for CS account away time. Notify accounts with manager-level permissions or higher, as well as the CS account that triggered the away time, when the away duration reaches the set time.',
	['最后暂离时间报表']: 'Last away time report',
	['平均最后暂离时间']: 'Average last away time',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{-name}} has been away for [{{minute}}] minutes!',
	['历史对话记录下载']: 'Historical conversation record download',
	['使用模式']: 'Usage mode',
	['标准模式']: 'Standard mode',
	['ID模式']: 'ID mode',
	['即进模式']: 'Instant access mode',
	['复制即进网址']: 'Copy instant access URL',
	['生成新网址']: 'Generate a new URL',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'Standard mode requires customer profile information and is the default system mode',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'Input an ID to access customer service without providing customer profile information',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'Use the instant access URL to directly access the customer service system without providing any information. The system will automatically assign a random visitor name',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'Please confirm whether to switch from [<<prevTypeText>>] to [<<nextTypeText>>]',
	['以下是即进网址']: 'Below is the instant access URL',
	['复制网址']: 'Copy URL',
	['使用模式切换成功']: 'Usage mode switched successfully',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'Please confirm whether to replace the URL. Once replaced, <<redText>>',
	['当前即进网址']: 'Current instant access URL',
	['新即进网址']: 'New instant access URL',
	['复制即进网址成功']: 'Instant access URL copied successfully',
	['报表统计']: 'Report statistics',
	['操作時間']: 'Operation time',
	['统计类型']: 'Statistical type',
	['请选择统计类型']: 'Please select a statistical type',
	['查询参数']: 'Query parameters',
	['申请时间']: 'Request time',
	['产出时间']: 'Output time',
	['申请帐号']: 'Request account',
	['详细资料']: 'Detailed information',
	['重新执行统计']: 'Re-execute statistics',
	['执行统计']: 'Execute statistics',
	['登入时间范围']: 'Login time range',
	['选择团队：筛选出该团队所有客服人员']: 'Select team: Filter out all customer service staff of the team.',
	['API接收日志']: 'API reception log',
	['新增来源']: 'Add source',
	['CS']: 'CS',
	['包网']: 'package网',
	['包网API']: 'API包网',
	['第 {{min}} - {{max}} 笔']: 'From {{min}} to {{max}} entries',
	['选择的日期区间需小于等于{{limit}}天']: 'The selected date range must be less than or equal to {0} days.',
	['请选择日期时间查询条件']: 'Please select the date and time query criteria.',
	['类型']: 'Type',
	['公司']: 'company',
	['请输入公司']: 'Please enter the company',
	['会员帐号']: 'Member account',
	['请输入会员帐号']: 'Please enter your member account.',
	['是否查看详细资料？']: 'Do you want to see the details?',
	['传送资料']: 'Transfer data',
	['CS回覆资料']: 'CS reply information',
	['内容']: 'Content',
	['请选择进入的公司']: 'Please select the company to enter.',
	['指令数据更新纪录']: 'Instruction data update record',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '1. Sorting mechanism: All company commands will be processed in a unified order to ensure the efficient operation of the system.',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '2. Data Isolation: Users can only view the update records of their own company and cannot see the records of other companies.',
	['微调训练']: 'Fine-tuning',
	['执行微调']: 'Fine-tuning',
	['操作帐号']: 'Account操作',
	['是否修改AI API?']: 'Should the AI API be modified?',
	['保存设置']: 'Save settings',
	['修改AI API成功']: 'AI API modified successfully',
	['请输入{{text}}']: 'Please enter {{text}}',
	['{{text}}不能超过{{limit}}字元']: '{{text}} cannot exceed {{limit}} characters',
	['AI API']: 'AI API',
	['微调训练记录']: 'Fine-tuning training record',
	['模型名称']: 'Model name',
	['新增文本']: 'Add text',
	['修改文本']: 'Modify text',
	['请输入名称']: 'Please enter a name',
	['取消修改微调文本']: 'Cancel modification of fine-tuning text',
	['角色不可为空']: 'The role cannot be empty.',
	['请选择角色']: 'Please choose a character.',
	['内容不可为空']: 'Content cannot be empty.',
	['请输入内容']: 'Please enter content.',
	['系统']: 'system',
	['会员']: 'member',
	['AI']: 'AI',
	['请确认是否取消？']: 'Please confirm whether to cancel?',
	['新增微调文本成功']: 'Add fine-tuning text successfully',
	['修改微调文本成功']: 'Text modification and fine-tuning successful.',
	['自定模型名称']: 'Custom model name',
	['微调确认讯息']: 'Fine-tuning confirmation message',
	['请确认是否执行微调训练？']: 'Please confirm whether to execute fine-tuning training?',
	['删除微调文本']: 'Delete fine-tuning text',
	['请确认是否刪除？']: 'Please confirm whether to delete?',
	['刪除微调文本成功']: 'Delete fine-tuning text successfully',
	['请输入模型名称']: 'Please enter the model name.',
	['执行微调成功']: 'Fine-tuning successful',
	['取消修改文本成功']: 'Cancel text modification successful',
	['取消新增文本成功']: 'Cancel new text successfully',
	['您已成功登出客服系统。']: 'You have successfully logged out of the customer service system.',
	['如需重新登录，请返回包网！']: 'To re-login, please return to the package network!',
	['您已成功登出客服系统管理端。']: 'You have successfully logged out of the customer service system management.',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'When the "average wait time" displays as 0 seconds, the possible reasons are as follows:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: 'The waiting time for all conversations on the day is 0 seconds (e.g., no waiting due to automatic answering or instant response).',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '2. According to the formula "Total daily waiting time ÷ Number of daily conversations," the calculated result, after rounding, is 0 seconds.',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'When the system displays "Not Logged In," it indicates that the account has not generated any conversation data within the set team time.',
	['加入微调']: 'Add fine-tuning',
	['启用API Key']: 'Enable API Key',
	['微调汇入对话记录']: 'Fine-tune the integration of conversation records',
	['对话数量']: 'Number of dialogues',
	['文本最后角色需为AI或客服人员']: 'The final role of the text should be AI or customer service personnel.',
	['汇入微调文本']: 'Import fine-tuning text',
	['檔案格式：CSV，且档案大小不得大于']: 'File format: CSV, and the file size must not exceed',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'The final role of the text must be AI or customer service personnel, please modify it before exporting or fine-tuning.',
	['批量加入微调']: 'Batch adding fine-tuning',
	['自定加入微调的名称']: 'Add custom fine-tuning name',
	['微调名称']: 'Fine-tuning name',
	['请输入微调的名称']: 'Please enter the name of the fine-tuning.',
	['微调的名称']: 'Fine-tuning name',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'Please confirm whether to delete in bulk (a total of {{selectedFineTuningRecordsLength}} entries',
	['已取消']: 'Canceled',
	['取消微调']: 'Cancel fine-tuning',
	['取消微调成功']: 'Tuning canceled successfully',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'When canceling the fine-tuning training of this customer service system, it is necessary to simultaneously cancel the corresponding fine-tuning training in the OpenAI backend. Only after both are canceled will the fine-tuning training be completely removed. Please confirm if you want to cancel this customer service system fine-tuning training?',
	['复制快捷语成功']: 'Copy shortcut successfully',
	['复制常用图片成功']: 'Successfully copied the commonly used image.',
	['左侧']: 'Left',
	['右侧']: 'right side',
	['{{text}}正在服务{{total}}则对话']: '{{text}} is serving {{total}} conversations.',
	['新增跑马灯成功']: 'Successfully added marquee.',
	['修改跑马灯成功']: 'Successful modification of the marquee.',
	['刪除跑马灯成功']: 'Delete marquee successfully',
	['启用跑马灯成功']: 'Marquee enabled successfully',
	['停用跑马灯成功']: 'Scrolling marquee disabled successfully',
	['对象栏位']: 'Object field',
	['显示跑马灯内容']: 'Show marquee content',
	['请确认是否启用跑马灯？']: 'Please confirm whether to enable the marquee?',
	['请确认是否停用跑马灯？']: 'Please confirm whether to disable the marquee?',
	['请确认是否删除跑马灯？']: 'Please confirm whether to delete the marquee?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} up to {{inputLimit}} groups',
	['数值范围']: 'value range',
	['数值不能为空']: 'The value cannot be empty.',
	['数值']: 'value',
	['请输入数字']: 'Please enter a number',
	['输入多组文字请用, 区隔']: 'Please separate multiple sets of text with commas.',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'When the user meets the specified name and field rules of the target object, the marquee promotion will take effect.',
	['新增跑马灯']: 'Add marquee',
	['对象栏位不能为空']: 'The object field cannot be empty.',
	['请输入对象栏位']: 'Please enter the object field.',
	['栏位规则']: 'Column rules',
	['栏位规则不能为空']: 'Field rules cannot be empty.',
	['请选择栏位规则']: 'Please select column rules',
	['开头图示']: 'Opening illustration',
	['开头图示不能为空']: 'The initial graphic cannot be empty.',
	['请选择开头图示']: 'Please select the opening illustration.',
	['跑马灯内容']: 'Scrolling marquee text',
	['修改跑马灯']: 'Modify marquee',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'The changes to the platform settings will be applied to the subordinate roles. Do you confirm the modification?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'Are you sure you want to delete the [personal/public] frequently used image [{{title}}]?',
	['一经确认删除无法复原。']: 'Once confirmed, deletion cannot be restored.',
	['客服日志']: 'Customer service log',
	['请输入内容等关键字']: 'Please enter content and key keywords.',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'Are you sure you want to delete the [personal/public] shortcut [{{title}}]: [{{content}}]?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'No other entry tag is opened, so this entry tag cannot be closed.',
	['没有其他进入标签被开启，故无法删除此标签']: 'No other entry tags have been opened, so this tag cannot be deleted.',
	['所有人']: 'Everyone',
	['自定义对象']: 'Custom object',
	['套用对象']: 'Target object',
	['回主画面']: 'Return to the main screen',
	['孟加拉语']: 'Bengali',
	['繁体中文']: 'Traditional Chinese',
	['简体中文']: 'Simplified Chinese',
	['韩语']: 'Korean',
	['日语']: 'Japanese',
	['葡萄牙语']: 'Portuguese',
	['印地语']: 'Hindi',
	['俄语']: 'Russian',
	['重要资讯']: 'Important information',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'Switching languages during a conversation may cause a delay of about 10 minutes in the message translation feature, affecting the reading of new and old messages. Are you sure you want to switch languages?',
	['暂无对话']: 'No dialogue available',
	['档案上传中']: 'Uploading files',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} has enabled automatic push notifications at {{time}}.',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} has turned off automatic push notifications at {{time}}.',
	['商户代码']: 'Merchant Code',
	['请输入商户代码']: 'Please enter merchant code',
	['密钥']: 'Secret Key',
	['请输入密钥']: 'Please enter secret key',
	['共同设定']: 'Common Settings',
	['充值未到帐设定']: 'Recharge Not Credited Settings',
	['出款未到帐设定']: 'Withdrawal Not Credited Settings',
	['确认进行储存？']: 'Confirm to save?',
	['SKILL开关']: 'SKILL Toggle',
	['请输入SKILL']: 'Enter SKILL',
	['派单 API 参数']: 'Dispatch Order API Parameters',
	['请输入派单API URL']: 'Enter Dispatch Order API URL',
	['开单者username']: 'Order Creator Username',
	['请输入开单者username']: 'Enter Order Creator Username',
	['频道名称']: 'Channel Name',
	['请输入频道名称']: 'Enter Channel Name',
	['开单原因']: 'Order Reason',
	['请输入开单原因']: 'Enter Order Reason',
	['充值订单查询 API URL']: 'Recharge Order Query API URL',
	['出款订单查询 API URL']: 'Withdrawal Order Query API URL',
	['同义词设定']: 'Synonym setting',
	['开启BM25']: 'Enable BM25',
	['同义词']: 'synonym',
	['更新时间']: 'Update time',
	['批次新增同义词']: 'Batch add synonyms',
	['修改同义词']: 'Modify synonym',
	['新增同义词']: 'Add synonym',
	['请输入同义词，使用逗号区隔不同词汇']: 'Please enter synonyms, separated by commas.',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'Please separate different words with commas and different groups of synonyms with semicolons.',
	['输入格式说明：']: 'Input format description:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'Please use commas to separate different vocabulary, such as: recharge, stored value, deposit, top-up',
	['词汇与标点符号前后不要出现空白']: 'Do not leave spaces before and after punctuation marks.',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'Please use a semicolon or line breaks (enter) to separate synonyms of the same group, for example:',
	['充值,储值,入金,课金']: 'Recharge',
	['log in,登入;亲,宝贝']: 'log in, login; dear, darling',
	['请输入同义词']: 'Please enter a synonym.',
	['同义词不可为空']: 'Synonyms cannot be empty.',
	['同义词格式有误']: 'The synonym format is incorrect.',
	['同义词不可有特殊字元']: 'Synonyms cannot have special characters.',
	['字元不可超过10000']: 'Character cannot exceed 10000.',
	['需至少输入两个词汇']: 'You need to enter at least two words.',
	['删除同义词']: 'Delete synonyms',
	['请确认是否删除同义词？']: 'Please confirm whether to delete the synonyms?',
	['新增同义词成功']: 'Successfully added synonym',
	['新增同义词失败']: 'Failed to add synonym',
	['修改同义词成功']: 'Synonym modification successful',
	['修改同义词失败']: 'Failed to modify synonyms',
	['删除同义词成功']: 'Successfully deleted synonym.',
	['删除同义词失败']: 'Failed to delete synonym',
	['内容有重复字']: 'The content has repeated words.',
	['新增图片，详细图片请参考公告管理']: 'Add image, for detailed images please refer to announcement management.',
	['目前只支援ChatGPT进行微调训练']: 'Currently, only ChatGPT supports fine-tuning training.',
	['AI系列']: 'AI series',
	['AI系列不能为空']: 'AI series cannot be empty',
	['启用ChatGPT']: 'Enable ChatGPT',
	['启用Gemini']: 'Enable Gemini',
	['AI客服']: 'AI customer service',
	['ID入口']: 'ID Entrance',
	['IP']: 'IP',
	['USER ID']: 'USER ID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}} content cannot be empty',
	['{{text}}仅能输入数字']: '{{text}} can only accept numbers',
	['{{text}}最多{{limit}}个字元']: '{{text}} up to {{limit}} characters',
	['{{text}}最多數字{{limit}}碼']: '{{text}} up to {{limit}} digits',
	['{{time}}分']: '{{time}} minutes',
	['{{time}}时']: '{{time}} o\'clock',
	['{{time}}秒']: '{{time}} seconds',
	['上一则发送后等待时间']: 'Time to wait after the previous message was sent',
	['上传图片']: 'Upload image',
	['主要API keys']: 'Main API keys',
	['主要语言']: 'Main language',
	['事件']: 'event',
	['以查看预览效果']: 'to preview',
	['依照选择模组设定UI显示位置及功能。']: 'Set the UI display position and functionality according to the selected module.',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'Adjust the color scheme according to the selected style (including background, frame, color scheme, and line sense).',
	['修改帐号履历成功']: 'Account profile updated successfully',
	['修改翻译API成功']: 'Modification of translation API successful',
	['充值帐号']: 'Recharge account',
	['共 {{numOfItems}} 笔']: 'Total {{numOfItems}} items',
	['关 闭']: 'Close',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'After closing, the entire push notification system will stop operating, and all push messages will temporarily become invalid. You can reopen it at any time.',
	['内容最多20字元']: 'Content up to 20 characters',
	['内容预览']: 'Content preview',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'After switching, the marquee text and shortcut keys may appear unclear or have insufficient contrast, and need to be reset in the backend.',
	['删除履历']: 'Delete resume',
	['删除帐号履历成功']: 'Account history deleted successfully',
	['删除跑马灯']: 'Remove marquee',
	['加载中...']: 'Loading...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'After checking, the account name will be displayed next to the account when contacting customer service.',
	['即时预览']: 'Instant preview',
	['取消新增微调文本']: 'Cancel add fine-tuning text',
	['古典深色风格']: 'Classical dark style',
	['單次']: 'single',
	['回传表单']: 'Submission Details',
	['外观风格']: 'Appearance style',
	['客户端视觉设定']: 'Client visual settings',
	['客户端视觉设定成功']: 'Client visual settings successfully set.',
	['尚无资料']: 'No data yet',
	['展开']: 'Expand',
	['履历数量']: 'Number of resumes',
	['帐号履历']: 'Account history',
	['帐号履历管理']: 'Account history management',
	['平台代码不能有空白']: 'Platform code cannot have whitespace',
	['平台代码仅能输入英文和数字']: 'Platform code can only contain English letters and numbers.',
	['平台代码最多5码']: 'Platform code up to 5 digits.',
	['平台代码最少2码']: 'Platform code must be at least 2 digits.',
	['平台语言']: 'Platform language',
	['平均首次工作时间']: 'Average first working time',
	['建立者']: 'Creator',
	['开关']: 'Switch',
	['快速通道']: 'Fast track',
	['手动推播']: 'Manual push notification',
	['手机版']: 'Mobile version',
	['批量删除']: 'Batch delete',
	['排序']: 'Sort',
	['推播功能']: 'Push notification feature',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'Push notification feature OFF: The push notification feature disables the entire system, making all strategies in the list invalid.',
	['推播时间']: 'Push notification time',
	['推播讯息列表']: 'Push notification list',
	['推播设定']: 'Push notifications setting',
	['操作内容']: 'Operation content',
	['收起']: 'Collapse',
	['数值/内容']: 'Value/Content',
	['数值/内容不可为空']: 'Value/content cannot be empty',
	['数值只能输入数字、负号、小数点']: 'The value can only be a number, negative sign, or decimal point.',
	['数值小数最多6位数']: 'The value can have up to 6 decimal places.',
	['数值整数最多15位']: 'The integer value can be up to 15 digits.',
	['新增履历']: 'Add resume',
	['新增帐号履历成功']: 'Account history added successfully',
	['新增类型']: 'Add type',
	['无工作']: 'Unemployed',
	['时间设定需至少为 3 分钟']: 'The time setting must be at least 3 minutes.',
	['是否修改翻译API?']: 'Should the translation API be modified?',
	['更新成功']: 'Update successful',
	['更新者']: 'Updater',
	['架构模组']: 'Architecture module',
	['栏位名称']: 'Column name',
	['栏位类型']: 'Column type',
	['栏位类型不可为空']: 'Column type cannot be empty',
	['档案格式不符']: 'File format is incorrect.',
	['PDF文件']: 'PDF document',
	['模式与间隔时间']: 'Mode and interval time',
	['欢迎回来']: 'Welcome back',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'This operation will automatically translate other languages, and the original input content will be overwritten by the translation results. Please confirm if you want to proceed?',
	['汇入']: 'Import',
	['汇入微调文本成功']: 'Import fine-tuning text successful',
	['汇出微调文本成功']: 'Export fine-tuning text successfully',
	['清空翻译']: 'Clear translation',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'All languages must be completed before confirming. You can use automatic translation to fill in the remaining languages.',
	['标题与内容皆需填写才可自动翻译']: 'Both the title and content must be filled in before automatic translation.',
	['状态持续时间']: 'Duration',
	['用户帐号']: 'User account',
	['用户帐号不能为空']: 'User account cannot be empty.',
	['电脑版']: 'Desktop version',
	['目前无适用推播']: 'Currently no applicable push notifications',
	['目前有启用中的侦测语言平台，无法关闭']: 'Currently, there is a detection language platform enabled and cannot be turned off.',
	['确定删除IP白名单？']: 'Are you sure you want to delete the IP whitelist?',
	['确定发送推播？']: 'Are you sure you want to send the push notification?',
	['确定要关闭推播功能吗？']: 'Are you sure you want to turn off the push notification feature?',
	['确认删除此笔履历?']: 'Confirm deletion of this record?',
	['确认要删除推播讯息？']: 'Are you sure you want to delete the push notification?',
	['立即登入']: 'Log in now',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'From {{min}} to {{max}} / A total of {{numOfItems}} items',
	['筛选条件']: 'Filter criteria',
	['类型名称']: 'Type Name',
	['系统预设模组']: 'System preset module',
	['经典浅色风格']: 'Classic light style',
	['翻译API']: 'Translation API',
	['聊天介面']: 'chat interface',
	['自动推播']: 'Automatic push notifications',
	['自动推播功能']: 'Push notification feature',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'Automatic push broadcast function OFF: All push messages in the list can still be manually executed by customer service, but all timer functions stop working.',
	['自定义']: 'Customize',
	['自定义文案']: 'Custom text',
	['自客服接起对话后开始计算']: 'Start calculating after the customer service picks up the conversation.',
	['该类型目前有推播讯息套用中，无法删除']: 'This type currently has push notifications applied, and cannot be deleted.',
	['详细说明']: 'detailed description',
	['请先选择推播类型']: 'Please select the push notification type.',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'Please confirm whether to delete in bulk (a total of {{selectedFineTuningRecordsLength}} items)?',
	['请输入事件']: 'Please enter the event',
	['请输入会员ID']: 'Please enter your member ID.',
	['请输入內容']: 'Please enter the content.',
	['请输入关键字']: 'Please enter keywords',
	['请输入您的会员 ID 以继续']: 'Please enter your member ID to continue.',
	['请输入数值/内容']: 'Please enter a value/content',
	['请输入文字']: 'Please enter text',
	['请输入栏位名称']: 'Please enter the field name.',
	['请输入用户帐号']: 'Please enter your user account.',
	['请输入类型名称']: 'Please enter the type name.',
	['请输入详细说明']: 'Please enter detailed instructions.',
	['请选择上方下拉选单']: 'Please select from the dropdown menu above.',
	['请选择主要语言自动翻译']: 'Please select the primary language for automatic translation.',
	['请选择帐号状态']: 'Please select account status',
	['请选择平台']: 'Please select a platform.',
	['请选择推播项目']: 'Please select the push notification item.',
	['请选择栏位类型']: 'Please select the field type.',
	['请选择类型']: 'Please choose a type',
	['请选择类型与项目(标题)以预览内容']: 'Please select the type and project (title) to preview the content.',
	['请选择表单选项']: 'Please select a form option.',
	['请选择运算规则']: 'Please select the calculation rule.',
	['请选择预览画面']: 'Please select the preview screen.',
	['跑马灯设定']: 'marquee setting',
	['轮播']: 'carousel',
	['轮播模式']: 'Carousel mode',
	['轮播间隔时间']: 'carousel interval time',
	['运算规则']: 'Operation rules',
	['运算规则不可为空']: 'The operation rules cannot be empty.',
	['返回上一层']: 'Return to the previous level',
	['返回上一页']: 'Go back to the previous page',
	['送出推播']: 'Send push notification',
	['选单介面']: 'Menu interface',
	['选择推播类型']: 'Select push type',
	['选择推播项目(标题)']: 'Select push notification item (title)',
	['通知时间']: 'notification time',
	['通知时间不能为空']: 'Notification time cannot be empty',
	['重新产生Key/IV']: 'Regenerate Key/IV',
	['重要客户']: 'key client',
	['需为1~60正整数']: 'It must be a positive integer from 1 to 60.',
	['预估时间']: 'Estimated time',
	['预览图片']: 'Preview image',
	['首次工作时间报表']: 'First Work Time Report',
	['日志管理']: 'Log Management',
	['API传送日志']: 'API Transmission Log',
	['订单号']: 'Order Number',
	['三方单号']: 'Third-party Order Number',
	['请输入订单号']: 'Please enter order number',
	['请输入三方单号']: 'Please enter third-party order number',
	['充值订单查询']: 'Recharge Order Query',
	['出款订单查询']: 'Withdrawal Order Query',
	['开派单']: 'Create Dispatch Order',
	['传送派单信息']: 'Send Dispatch Information',
	['CS传送资料']: 'CS Sent Data',
	['平台回覆资料']: 'Platform Reply Data',
	['{{text}}需以{{prefix}}开头']: '{{-text}} must start with {{-prefix}}',
	['系统通知']: 'System Notification',
	['派单传送讯息']: 'Dispatch Send Message',
	['派单传送档案']: 'Dispatch Send File',
	['请输入平台']: 'Please enter the platform.',
	['派单讯息润饰设定']: 'Dispatch Message Polish Settings',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'This instruction does not load "AI common setting" or "Platform AI settings"; it operates as an independent Agent.',
	['用户个人设定']: 'User Personal Settings',
	['新增用户个人资讯']: 'Add User Personal Info',
	['个人资讯参数名称']: 'Personal Info Parameter Name',
	['请输入个人资讯参数名称']: 'Please enter the personal info parameter name',
	['*新增多个请使用逗号「 , 」隔开']: '*To add multiple, separate them with commas "，"',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'Used to set which personal info on this platform is sent to AI. Only parameters set in "User Personal Settings" will be sent to AI.',
	['批次删除用户个人资讯']: 'Batch Delete User Personal Info',
	['确定要批次删除用户个人资讯吗？']: 'Are you sure you want to batch delete user personal info?',
	['个人资讯参数名称不能为空']: 'Personal info parameter name cannot be empty',
	['已存在「{{name}}」']: '"{{-name}}" already exists',
	['最多可新增{{limit}}个，已超过上限']: 'You can add up to {{-limit}}; the limit has been exceeded',
	['新增用户个人资讯成功']: 'User personal info added successfully',
	['新增用户个人资讯失败']: 'Failed to add user personal info',
	['删除用户个人资讯成功']: 'User personal info deleted successfully',
	['删除用户个人资讯失败']: 'Failed to delete user personal info',
	['图像管理']: 'Image Management',
	['自定义图像']: 'Custom Image',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'File format: "PNG, JPG", file size must not exceed 500KB',
	['档案最大500K']: 'File size up to 500K',
	['新增图像成功']: 'Image added successfully',
	['删除图像成功']: 'Image deleted successfully',
	['是否确定删除图像？']: 'Are you sure you want to delete this image?',
	['内容设定']: 'Content settings',
	['英语']: 'English',
	['{{language}}内容']: '{{language}} content',
	['请输入{{language}}内容']: 'Please enter {{language}} content',
	['请选择时间']: 'Please select a time',
	['请选择公司']: 'Please select a company',
	['请输入{{label}}']: 'Please enter {{label}}',
	['原文参考（{{language}}）']: 'Original text reference ({{language}})',
	['确定清空设定吗？']: 'Are you sure you want to clear the settings?',
	['确定取消设定吗？']: 'Are you sure you want to cancel the settings?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'Incomplete',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}} {{label}} exceeds {{limit}} characters',
	['公告标题']: 'Announcement Title',
	['进线IP']: 'Incoming IP',
	['请输入进线IP']: 'Please enter incoming IP',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'Model switched: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'After the account is deleted in the BW backend, the corresponding customer service account will be deleted synchronously.',
	['系统已有新版本，请重新整理']: 'A new version is available, please refresh',
	['页面加载失败，请重试']: 'Failed to load the page, please retry',
	['翻译中']: 'Translating',
	['监控与即时摘要设定']: 'Monitoring & Instant Summary Settings',
	['批量转接']: 'Batch Transfer',
	['已选 {{count}} 则对话']: 'Selected {{count}} conversations',
	['勾选']: 'Select',
	['全平台服务人数']: 'Number of service personnel (all platforms)',
	['未开启{{platform}}平台']: '{{-platform}} platform is not enabled',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: 'Successfully transferred from {{-inviter}} to {{-invitee}}, {{count}} in total.',
	['接受']: 'Accept',
	['拒绝({{seconds}}S)']: 'Reject({{seconds}}S)',
	['生成链接']: 'Generate link',
	['链接生成中...']: 'Generating link...',
	['复制链接']: 'Copy link',
	['已复制链接']: 'Link copied',
	['人工回复']: 'Manual Reply',
	['检视回复']: 'View Reply',
	['{{time}} AI 拦截对话']: '{{time}} AI Intercepted',
	['档案上传失败']: 'File upload failed',
	['转档失败，请重新上传']: 'Conversion failed, please upload again',
	['AI 拦截原因与人工回复']: 'AI Interception Reason & Manual Reply',
	['人工回复失败']: 'Manual reply failed',
	['回复讯息']: 'Reply Message',
	['对话摘要']: 'Conversation Summary',
	['建议回复']: 'Suggested Reply',
	['拦截原因']: 'Interception Reason',
	['拦截回复']: 'Intercepted Reply',
	['确定送出']: 'Confirm and Send',
	['生成链接失败']: 'Failed to generate link',
	['连接超时，请稍后再试']: 'Connection timed out, please try again later',
	['上一则']: 'Previous',
	['下一则']: 'Next',
	['重新传送']: 'Resend',
	['传送中...']: 'Sending...',
	['用户端翻译失败']: 'Translation failed for client',
	['重新传送失败']: 'Resend failed',
	['请确认是否删除以下模型？']: 'Are you sure you want to delete the following model?',
	['新增模型']: 'Add Model',
	['请选择AI系列']: 'Please select an AI series',
	['支援模型']: 'Supported Model',
	['支援模型不能为空']: 'Supported model cannot be empty',
	['请选择支援模型']: 'Please select a supported model',
	['AI模型管理']: 'AI Model Management',
	['模型不能为空']: 'Model cannot be empty',
	['请选择模型']: 'Please select a model',

	['对话类型']: 'Conversation type',
	['单纯AI讯息']: 'AI messages only',
	['单纯人员讯息']: 'Personnel messages only',
	['人员+AI讯息']: 'Personnel + AI messages',
	['是否经过AI拦截']: 'Intercepted by AI?',
	['是否修改AI拦截建议回覆']: 'AI suggested reply modified?',
	['监控API keys']: 'Monitoring API keys',
	['管理']: 'Manage',

	['启用显性快取']: 'Enable Explicit Cache',
	['AI监控拦截总量']: 'Total number of AI monitoring interceptions',
	['AI监控拦截']: 'AI monitoring interceptions',
	['有修改建议回覆总量']: 'with suggested reply modified',
	['触发关键字：{{keywords}}。']: 'Triggered keywords: {{-keywords}}.',

	['版面已套用，但尚未同步至帐号']: 'Layout applied, but not yet synced to your account',
	['服务器重设失败，下次开启工作区时会再同步']: 'Failed to reset on the server; it will sync again next time you open the workspace',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'The browser cannot save the layout; please make sure it is synced to your account before leaving',

	['重设版面配置']: 'Reset layout',
	['确定要将版面配置回复为系统预设吗？']: 'Reset the layout to the system default?',
	['客服支援语言']: 'Supported Languages',
	['请选择支援语言']: 'Please select supported languages',
	['请选择客服支援语言']: 'Please select supported languages',

	['删除平台']: 'Delete Platform',
	['是否确定删除{{code}}平台']: 'Are you sure you want to delete platform {{-code}}?',
	['删除{{code}}平台成功']: 'Platform {{-code}} deleted successfully.',
	['上传图片或PDF']: 'Upload image or PDF',
	['当前平台维护中，如有疑问请联系管理员']: 'The current platform is under maintenance. Please contact the administrator if you have any questions.',
	['当前平台已禁用，如有疑问请联系管理员']: 'The current platform has been disabled. Please contact the administrator if you have any questions.',
	['收回提示文字']: 'Withdrawal prompt text',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'Please enter the prompt text, for example: Sorry dear, I sent the wrong message, please correct it!',
	['标签名称']: 'Label name',
	['预览失败']: 'Preview failed',
	['放大']: 'Zoom in',
	['缩小']: 'Zoom out',
	['上一页']: 'Previous page',
	['下一页']: 'Next page',
	['点击预览']: 'Click to preview',
};
